import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const structuredAnswers = {}
  result.map(answer => addAnswerStructuredByChapter(structuredAnswers, answer))
  const newState = {
    ...state,
    answers: structuredAnswers,
    isLoading: false,
  }
  return newState
}

const addAnswerStructuredByChapter = (structuredAnswers, answer) => {
  if (chapterNotExists(structuredAnswers, answer.kapitelId)) {
    addChapter(structuredAnswers, answer.kapitelId)
  }
  addAnswer(structuredAnswers, answer)
  updateFinishedAnswersCount(answer, structuredAnswers)
}

const chapterNotExists = (existingAnswers, kapitelId) => !existingAnswers[kapitelId]

const addChapter = (existingAnswers, kapitelId) => {
  existingAnswers[kapitelId] = {finishedAnswersCount: 0}
}

const addAnswer = (structuredAnswers, answer) => {
  structuredAnswers[answer.kapitelId][answer.frageId] = answer
}

let updateFinishedAnswersCount = (answer, structuredAnswers) => {
  if (answer.done) {
    structuredAnswers[answer.kapitelId].finishedAnswersCount += 1
  }
}

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action() {
  try {
    return await Api.getAnswers()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
